// src/data/changeLog.js

export const CHANGELOG_CONFIG = [
  {
    date: "2026-06-06",
    version: "0.1.0",
    comments: ["初版作成", "基本画面の実装"],
  },
  {
    date: "2026-06-09",
    version: "0.1.1",
    comments: [
      "トップページくじ並び替え（最新抽選日順）",
      "各くじ説明文・抽選曜日追加",
      "フッターにバージョン表示・changelogリンク追加",
    ],
  },
  {
    version: "0.2.0",
    date: "2026-06-16",
    comments: [
      "統計ページ追加（各くじの配当金・当選口数・期待値等）",
      "詳細ページURLをパス形式に変更（/detail/1157形式）",
      "詳細ページに総合払戻・販売実績枚数を追加",
      "くじ横断ナビ・ページナビを追加",
      "グローバルナビをグループ化",
      "トップページ並び替え時のちらつきを修正",
      "お知らせページをアコーディオン形式にリニューアル",
    ],
  },
  {
    version: "0.3.0",
    date: "2026-06-21",
    comments: [
      "AI解析機能追加（詳細ページ・一覧ページ）",
      "くじ横断ナビ改善（最新・統計ページを維持して移動）",
      "ナンバーズ3・4データ修正（第1〜2700回）",
    ],
  },
  {
    version: "0.4.0",
    date: "2026-08-29",
    comments: [
      "詳細ページに「出目が似ている過去の抽選」セクション追加（当選数字の並びが似ている過去回を最大5件アコーディオン表示）",
      "古い回（2008年頃以前）で払戻データが無い場合の表示を改善",
    ],
  },
  // {
  //   date: "2026-06-10",
  //   version: "0.1.1",
  //   comments: [
  //     "ログイン不具合修正",
  //     "UIの軽微な調整",
  //   ],
  // },
];
